// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/extensions
import { Store } from '@/utils/formStore/lib/main.js';

function useForm(vm) {
  const formRef = vm;
  if (vm.current) {
    formRef.current = vm.current;
  } else {
    const StoreDefault = Store.default;
    const formStore = new StoreDefault({});
    formRef.current = formStore;
  }
  return [formRef.current];
}
export default useForm;
